import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { StakeholderBulkAction, StakeholderBulkActionDto } from '../../types/stakeholder.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useBulkActions = () => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.GET_STAKEHOLDERS);
  const { mutate: bulkActions, isPending } = useAppMutation([QueryKey.BULK_STAKEHOLDER_ACTIONS], {
    mutationFn: ({
      action,
      ...body
    }: {
      action: StakeholderBulkAction;
    } & StakeholderBulkActionDto) =>
      ApiService.post<StakeholderBulkActionDto>(
        {
          endpoint: BackendRoute.STAKEHOLDERS,
          routePath: ['bulk', action],
        },
        { body },
      ),
    onSuccess: () => {
      invalidateQuery();
    },
  });
  return { bulkActions, isPending };
};
